import React from "react";
import "./FormElements.scss";

const TextAreaElement = ({ formik, field, formStateHook, tabIndexData }) => {
  const { formState } = formStateHook;
  return (
    <>
      {formState === "view" ? (
        <p style={{ textAlign: "justify", fontWeight: "500" }}>
          {formik?.values?.[field.name] !== "" ? (
            formik?.values?.[field.name]
          ) : (
            <span className="placeholder-disabled">{field.placeholder}</span>
          )}
        </p>
      ) : (
        <textarea
          id={field.name}
          name={field.name}
          className="form-control"
          style={{ borderColor: "#d3d3d3" }}
          onChange={formik.handleChange}
          value={formik?.values?.[field.name]}
          placeholder={field.placeholder}
          disabled={formState === "view" ? true : false}
          tabIndex={tabIndexData?.[field?.fieldId]}
        />
      )}
    </>
  );
};

export default TextAreaElement;
